<template>
  <v-container>
    <v-layout row wrap>
      <v-flex xs12 md8 offset-md2>
        <h1 class="primary--text mb-4">Create State</h1>
        <app-alert class="mb-3" type="error" :message="error" @dismissed="error = false" />

        <v-card>
          <v-card-title class="subheading font-weight-bold px-4">
            <span>State Details</span>
            <v-spacer></v-spacer>
            <v-icon @click="$router.go(-1)">close</v-icon>
          </v-card-title>
          <v-divider></v-divider>
          <v-form ref="form" @submit.prevent="doCreateState">
            <v-container class="px-4">
              <v-layout justify-space-between row wrap>
                <v-flex xs12 sm6>
                  <v-text-field
                    label="Name"
                    type="text"
                    v-model="state.name"
                    :rules="[rules.isRequired]"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-select
                    label="Status"
                    type="text"
                    v-model="state.status"
                    :items="statusOptions"
                    required
                  ></v-select>
                </v-flex>
              </v-layout>

              <v-layout class="mt-4 mb-1">
                <v-btn depressed color="accent" type="submit" :disabled="isSaving">
                  Create
                  <v-progress-circular
                    class="ml-2"
                    :indeterminate="true"
                    :size="18"
                    :width="2"
                    v-if="isSaving"
                  ></v-progress-circular>
                </v-btn>
              </v-layout>
            </v-container>
          </v-form>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { STATE_CREATE } from '@/store/actions/state'
import { statusOptions } from '@/data/options'

export default {
  name: 'CreateState',
  data () {
    return {
      isSaving: false,
      statusOptions: statusOptions,
      state: {
        name: '',
        status: 'active',
        country_id: this.$settings.country
      },
      error: false,
      rules: {
        isRequired: value => this.$validator.isRequired(value)
      }
    }
  },
  methods: {
    doCreateState () {
      if (!this.$refs.form.validate()) return
      this.error = false
      this.isSaving = true
      this.$store.dispatch(STATE_CREATE, this.state)
        .then(() => this.$router.push('/states?stateCreated=1'))
        .catch(error => (this.error = error.message))
        .finally(() => (this.isSaving = false))
    }
  }
}
</script>
